import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";

export default function Auth({ mode = "login" }) {
  const isLogin = mode === "login";
  const { login, register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "child" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = isLogin ? await login(form.email, form.password) : await register(form);
      toast.success(isLogin ? "Welcome back!" : "Account created!");
      nav(u.role === "parent" ? "/parent" : "/child");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Something went wrong");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-childhub flex items-center justify-center p-4">
      <div className="w-full max-w-md child-card p-8">
        <div className="text-center mb-6">
          <div className="inline-block bg-sky-400 text-white font-display text-3xl rounded-2xl px-5 py-2 shadow-[0_4px_0_#0284C7]">TLQ</div>
          <h1 className="font-display text-3xl font-bold text-slate-800 mt-4">{isLogin ? "Welcome back!" : "Join the Quest"}</h1>
          <p className="text-slate-500 text-sm">{isLogin ? "Sign in to keep learning" : "Pick a role and let's go"}</p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          {!isLogin && (
            <input data-testid="reg-name" required value={form.name} onChange={e=>setForm({...form, name:e.target.value})}
              placeholder="Your name" className="w-full rounded-2xl border-2 border-slate-200 px-4 py-3 focus:border-sky-400 outline-none"/>
          )}
          <input data-testid={isLogin?"login-email":"reg-email"} required type="email" value={form.email}
            onChange={e=>setForm({...form, email:e.target.value})} placeholder="Email"
            className="w-full rounded-2xl border-2 border-slate-200 px-4 py-3 focus:border-sky-400 outline-none"/>
          <input data-testid={isLogin?"login-password":"reg-password"} required type="password" value={form.password}
            onChange={e=>setForm({...form, password:e.target.value})} placeholder="Password" minLength={6}
            className="w-full rounded-2xl border-2 border-slate-200 px-4 py-3 focus:border-sky-400 outline-none"/>

          {!isLogin && (
            <div className="grid grid-cols-2 gap-3">
              <button type="button" onClick={()=>setForm({...form, role:"child"})}
                data-testid="role-child-btn"
                className={`rounded-2xl p-4 font-display font-bold border-4 transition ${form.role==="child"?"bg-sky-400 text-white border-sky-500 shadow-[0_4px_0_#0284C7]":"bg-white text-slate-700 border-slate-200"}`}>
                Kid
              </button>
              <button type="button" onClick={()=>setForm({...form, role:"parent"})}
                data-testid="role-parent-btn"
                className={`rounded-2xl p-4 font-display font-bold border-4 transition ${form.role==="parent"?"bg-indigo-600 text-white border-indigo-700 shadow-[0_4px_0_#3730A3]":"bg-white text-slate-700 border-slate-200"}`}>
                Parent
              </button>
            </div>
          )}

          <button disabled={loading} type="submit" data-testid={isLogin?"login-submit":"register-submit"}
            className="btn-child w-full text-lg disabled:opacity-60">
            {loading ? "..." : isLogin ? "Sign In" : "Create Account"}
          </button>
        </form>
        <p className="text-center text-sm text-slate-500 mt-4">
          {isLogin ? <>New here? <Link to="/register" className="text-sky-600 font-bold" data-testid="goto-register">Sign up</Link></>
                   : <>Have an account? <Link to="/login" className="text-sky-600 font-bold" data-testid="goto-login">Sign in</Link></>}
        </p>
      </div>
    </div>
  );
}
